export default {
    navigationBarTitleText: '福昕家装 · 智能设计'
};